<form [formGroup]="formGroup">
  <div class="headline">
    @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN' && displayEditingTools) {
      <div class="w49">
        <span class="mat-h1"> Sprachhandlung - </span>
        <mat-form-field appearance="outline" class="marg-right2">
          <mat-label>Name</mat-label>
          <input formControlName="name" matInput placeholder="" required>
        </mat-form-field>
      </div>
    } @else {
      <span class="h1 m0">Sprachhandlung - {{ verbalAction?.name }}</span>
    }
    @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN') {
      <span class="editing-group">
        @if (displayEditingTools === true && authService.getUserRole() === 'ROLE_ADMIN') {
          <button color="primary" mat-flat-button
                  (click)="toggleEditingTools(true); saveChanges()">
            <mat-label>Speichern</mat-label>
          </button>
        }
        @if ((displayEditingTools === false) && (authService.getUserRole() === 'ROLE_ADMIN')) {
          <button (click)="toggleEditingTools(true)"
                  aria-label="Button to enable editing"
                  class="editing-buttons header-buttons" mat-flat-button>
            <mat-icon>edit</mat-icon>
            <mat-label class="home-new-word-bt-text">Bearbeiten</mat-label>
          </button>
        }
      </span>
    }
  </div>
  <hr>
  <div class="main-content-wrapper">
    <!-- Examples Section -->
    <div class="mat-elevation w60 min-height-50 background-white pad16">
      <div class="">
        <span class="h5">Beispiele</span>
      </div>
      @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN' && displayEditingTools) {
        <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
          <mat-label>Beispiele (ein Beispiel pro Zeile)</mat-label>
          <textarea formControlName="examples" matInput rows="10"></textarea>
        </mat-form-field>
      } @else {
        <div class="examples-list pad-top8">
          @if (verbalAction?.examples && verbalAction.examples.length > 0) {
            <ul>
              @for (example of verbalAction.examples; track example) {
                <li>{{ example }}</li>
              }
            </ul>
          } @else {
            <p>Keine Beispiele vorhanden.</p>
          }
        </div>
      }
    </div>

    <div class="w39 pad16 mat-elevation">
      <div class="pad-bot8">
        <span class="h5">Details</span>
      </div>
      <!-- Edit View -->
      @if (authService.isLoggedIn() && authService.getUserRole() === 'ROLE_ADMIN' && displayEditingTools) {
        <div class="flex-col pad-top8">
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Rezeptiv</mat-label>
            <mat-select formControlName="receptive">
              @for (option of levelList; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Produktiv</mat-label>
            <mat-select formControlName="productive">
              @for (option of levelList; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- View Mode -->
      } @else {
        <div class="h6 pad-top8">
          <span>Rezeptiv: {{ verbalAction?.receptive }}</span>
        </div>
        <div class="h6 pad-top8">
          <span>Produktiv: {{ verbalAction?.productive }}</span>
        </div>
      }
      <app-reference-table
        [entry]="references"
        [editMode]="true"
        [clickableRefs]="true"
        (entryChange)="handleReferenceChange($event)">
      </app-reference-table>
    </div>
  </div>
</form>
